import React from 'react';

import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import Spinner from '~/components/icons/Spinner.tsx';
import { HistorySection } from '~/features/leadDetails/components/BankCreditRequest/OfferHistory/HistorySection';
import { HistoryTable } from '~/features/leadDetails/components/BankCreditRequest/OfferHistory/HistoryTable';
import { useOfferHistory } from '~/features/leadDetails/hooks/useOfferHistory.ts';

type Props = {
    lead: SchemaLoanRequestResolver_Get;
};

export const OfferHistory: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();
    const offerHistory = useOfferHistory(lead);

    if (offerHistory.isLoading) {
        return (
            <div className="w-full inset-0 flex items-center justify-center z-50">
                <Spinner />
            </div>
        );
    }

    if (offerHistory?.groupedOfferRequests == null || Object.values(offerHistory.groupedOfferRequests).length === 0)
        return <div className="text-center">{t('BANK_CREDIT_REQUEST.HISTORY.TABLE.NO_HISTORY')}</div>;

    return (
        <div className="flex w-full flex-col gap-2 overflow-y-hidden">
            {Object.entries(offerHistory.groupedOfferRequests).map(
                ([requestId, { conditions, countCreatedOffers, offers }], index) => {
                    if (offers.length === 0) return null;
                    return (
                        <HistorySection
                            hasSecondApplicant={!!lead.antragsteller2}
                            defaultOpen={index === 0}
                            key={`${requestId}-${index}`}
                            requestedAt={offers[0].createdAt}
                            offerCount={countCreatedOffers}
                            conditions={conditions}
                        >
                            <HistoryTable offers={offers} />
                        </HistorySection>
                    );
                },
            )}
        </div>
    );
};
